import {
  selectBrand,
  selectFavoriteFilter,
  selectTag,
} from "@shared/actions/games";
import { SHOW_ALL } from "@shared/constants/game";
import {
  useCurrentBrandId,
  useComputedBrands,
} from "@shared/hooks/games/brands";
import { useIsFavoriteFilterActive } from "@shared/hooks/games/games";
import { filterByCountOfGames } from "@shared/utils";
import cx from "classnames";
import React, { memo, useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";

const SECTION_CLASS =
  "tabset__item tabset__item__section tabset__item_sections";
const SELECTED_CLASS = "tabset__item--selected";
const DISABLE_CLASS = "tabset__item--disabled";

const Sections = () => {
  const currentBrandId = useCurrentBrandId();
  const computedBrands = useComputedBrands();
  const isFavoriteFilterActive = useIsFavoriteFilterActive();
  const dispatch = useDispatch();
  const intl = useIntl();
  const handleSectionClick = useCallback(
    (event) => {
      const id = Number.parseInt(event.target.dataset.id, 10);

      if (id !== SHOW_ALL && isFavoriteFilterActive) {
        dispatch(selectTag(SHOW_ALL));
        dispatch(selectFavoriteFilter(false));
      }
      dispatch(selectBrand(id));
    },
    [dispatch, isFavoriteFilterActive]
  );

  const isHidden = useMemo(
    () => filterByCountOfGames(computedBrands).length <= 1,
    [computedBrands]
  );

  return (
    <div className="tabset tabset--menu tabset--divide" role="list">
      <div
        className={cx(SECTION_CLASS, {
          [SELECTED_CLASS]: currentBrandId === -1,
        })}
        data-id="-1"
        role="listitem"
        onClick={handleSectionClick}
      >
        {intl.formatMessage({ id: "all", defaultMessage: "All" })}
      </div>

      {!isHidden &&
        computedBrands.map((brand) => (
          <div
            key={brand.id}
            className={cx(SECTION_CLASS, {
              [SELECTED_CLASS]: currentBrandId === brand.id,
              [DISABLE_CLASS]: !brand.games_count,
            })}
            onClick={handleSectionClick}
            data-id={brand.id}
            role="listitem"
          >
            {brand.name}
          </div>
        ))}
    </div>
  );
};

export default memo(Sections);
